import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StoreService {

    STORAGE_KEY = '@@VZWIKI';

    apiError?: any;
    apiErrorTitle?: string;

    private _s!: Storage;

    public hlWorker?: Worker;
    public hlWorkerMessage: Subject<any> = new Subject();

    constructor() {
        this._s = sessionStorage.getItem(this.STORAGE_KEY) ? sessionStorage : localStorage;
        // const ver = this._s.getItem(this.STORAGE_KEY);
        if (typeof Worker !== 'undefined') {
            // console.log('=[hl]=[StoreService]==> create hlWorker');
            this.hlWorker = new Worker(new URL('./highlight.worker', import.meta.url));
            this.hlWorker.onmessage = (ev) => this.hlWorkerMessage.next(ev);
            // console.log('=[hl]=[StoreService]==> hlWorker:', this.hlWorker, 'onmessage registered');
        }
    }

    setStorageType(local = true): void {
        this._s = local ? localStorage : sessionStorage;
    }

    getItem(key: string, defValue?: any): any {
        const value = this._s.getItem(this.STORAGE_KEY + '_' + key);
        let res = defValue;
        if (value !== null) {
            try {
                res = JSON.parse(value);
            }
            catch {
                res = defValue;
            }
        }
        return res;
    }

    setItem(key: string, value: any): void {
        this._s.setItem(this.STORAGE_KEY + '_' + key, JSON.stringify(value));
    }

    deleteItem(key: string): void {
        this._s.removeItem(this.STORAGE_KEY + '_' + key);
    }

}
